var _circle, _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconThumbUp = function SvgIconThumbUp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 142,
    height: 142,
    fill: "none",
    viewBox: "0 0 142 142"
  }, props), /*#__PURE__*/React.createElement("g", {
    filter: "url(#icon-thumb-up-filter0_dd_197:21522)"
  }, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 71,
    cy: 67,
    r: 66,
    fill: "#FFF"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "icon-thumb-up-mask0_197:21522",
    width: 64,
    height: 64,
    x: 39,
    y: 32,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "alpha"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M103 32H39v64h64z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon-thumb-up-mask0_197:21522)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#30B7FD",
    d: "M80 46c-.1 0-.2 0-.3-.1-.5-.2-.8-.8-.6-1.3l2-5.6c.2-.5.8-.8 1.3-.6.6.2.8.8.6 1.3l-2 5.6c-.2.4-.5.7-1 .7M67 46c-.4 0-.8-.3-.9-.7l-2-5.6c-.2-.5.1-1.1.6-1.3s1.1.1 1.2.6l2.1 5.7c.2.5-.1 1.1-.6 1.3zM73.5 44.898c-.6 0-1-.4-1-1v-6c0-.6.4-1 1-1s1 .4 1 1v6c0 .5-.4 1-1 1"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00293C",
    d: "M86.4 92.998H68.2c-6.2 0-11.2-5-11.2-11.2v-13.2c0-.6.4-1 1-1 2.1 0 7.7-5.2 10.3-13.4.2-.6.3-1.4.5-2.1.5-2.4 1-5 3.3-5q3.6 0 5.4 3.9c2.3 5.1.9 9.4-.3 11.6h11.3c2.5 0 4.6 2 4.6 4.6 0 1.4-.7 2.7-1.7 3.6 1 .8 1.7 2.1 1.7 3.6 0 1.7-.9 3.2-2.3 4 .8.8 1.3 1.9 1.3 3.2 0 1.7-.9 3.2-2.3 4 .8.8 1.3 1.9 1.3 3.2-.1 2.2-2.2 4.2-4.7 4.2M59 69.398v12.4c0 5.1 4.1 9.2 9.2 9.2h18.2c1.4 0 2.6-1.1 2.6-2.6s-1.1-2.6-2.6-2.6h-3.1c-.6 0-1-.4-1-1s.4-1 1-1h4.1c1.4 0 2.6-1.1 2.6-2.6 0-1.4-1.1-2.6-2.6-2.6h-3.1c-.6 0-1-.4-1-1s.4-1 1-1h4.2c1.4 0 2.6-1.1 2.6-2.6 0-1.4-1.1-2.5-2.5-2.6-1.6.1-2.5.1-3.2 0-.8-.1-1-.4-1-.9s.3-1 .9-1.1h3.3c.2 0 .5-.1.6-.1 1.1-.2 2-1.3 2-2.5 0-1.4-1.1-2.6-2.6-2.6H75.3q-.6 0-.9-.6c-.2-.4-.1-.8.1-1.1.2-.2 3.9-4.8 1.1-11.1-1.1-2.1-2.4-2.4-3.5-2.4-.6 0-1.1 2.1-1.3 3.4-.2.8-.3 1.6-.6 2.4-2.4 7.6-7.7 13.6-11.2 14.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00293C",
    d: "M55 92.996h-3c-2.2 0-4-1.8-4-4v-20.5c0-2.2 1.8-4 4-4h3c2.2 0 4 1.8 4 4v20.5c0 2.2-1.8 4-4 4m-3-26.5c-1.1 0-2 .9-2 2v20.5c0 1.1.9 2 2 2h3c1.1 0 2-.9 2-2v-20.5c0-1.1-.9-2-2-2z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "icon-thumb-up-filter0_dd_197:21522",
    width: 142,
    height: 142,
    x: 0,
    y: 0,
    colorInterpolationFilters: "sRGB",
    filterUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 1,
    result: "effect1_dropShadow_197:21522"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.06 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_197:21522"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    result: "hardAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    "in": "SourceAlpha",
    radius: 1,
    result: "effect2_dropShadow_197:21522"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_197:21522",
    result: "effect2_dropShadow_197:21522"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect2_dropShadow_197:21522",
    result: "shape"
  })))));
};
export default SvgIconThumbUp;